import { PHONE_SOURCE_OPTIONS, modeInfoIdFor } from "../lib/eam";
import type { EamPhoneSource, EamSignInApp } from "../types/api";
import ModeInfoTip from "./ModeInfoTip";

interface Props {
  value: EamPhoneSource;
  onChange: (s: EamPhoneSource) => void;
  name: string;
  /** Change mode: the note under the two Entra options. */
  entraNote?: string;
  /** The realm's sign-in app: "Added on this page" reads differently on each. */
  signInApp: EamSignInApp | null;
}

export default function PhoneSourceOptions({ value, onChange, name, entraNote, signInApp }: Props) {
  return (
    <div className="mt-2 space-y-2 text-sm">
      {PHONE_SOURCE_OPTIONS.map((o) => {
        const inputId = `${name}-${o.value}`;
        return (
          <div key={o.value} className="flex items-start gap-2">
            <input
              id={inputId}
              type="radio"
              name={name}
              className="mt-1"
              checked={value === o.value}
              onChange={() => onChange(o.value)}
            />
            <div>
              <div className="flex items-center gap-1.5">
                <label htmlFor={inputId} className="font-bold">
                  {o.title}
                </label>
                <ModeInfoTip id={modeInfoIdFor(o.value, signInApp)} />
              </div>
              <label htmlFor={inputId} className="block text-gray-500">
                {o.body}
              </label>
              {entraNote && o.entra && <p className="text-gray-500">{entraNote}</p>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
